import { Locale } from 'chaika-enums';
export const patientModule = {
    patientHasDebt: {
        [Locale.Ru]: 'У пациента есть задолженность – личный кабинет и запись на услуги недоступны. ',
        [Locale.Am]: 'Պացիենտն ունի պարտք – անձնական հաշիվը և ծառայությունների գրանցումն անհասանելի են։ ',
        [Locale.En]: 'The patient has a debt - the personal account and registration for services are not available. ',
        [Locale.Pt]: 'O paciente possui um débito - a conta pessoal e o agendamento de serviços não estão disponíveis.',
        [Locale.Ge]: 'The patient has a debt - the personal account and registration for services are not available. ',
    },
    crossCountryMedicalData: {
        [Locale.Ru]: 'В карте есть медицинские данные из клиники в другой стране. Пациент может предоставить их вам из своего личного кабинета',
        [Locale.Am]: 'Քարտում կան բժշկական տվյալներ այլ երկրի կլինիկայից։ Պացիենտը կարող է տրամադրել դրանք ձեզ իր անձնական հաշվից',
        [Locale.En]: 'The chart contains medical data from a clinic in another country. The patient can share it with you from their personal account',
        [Locale.Pt]: 'O prontuário contém dados médicos de uma clínica em outro país. O paciente pode compartilhá-los com você a partir da sua conta pessoal',
        [Locale.Ge]: 'The chart contains medical data from a clinic in another country. The patient can share it with you from their personal account',
    },
    nameInEnglish: {
        [Locale.Ru]: `Имя на английском`,
        [Locale.Am]: `Անուն անգլերենով`,
        [Locale.En]: `Name in English`,
        [Locale.Pt]: 'Nome em inglês',
        [Locale.Ge]: `Name in English`,
    },
    lastNameInEnglish: {
        [Locale.Ru]: `Фамилия на английском`,
        [Locale.Am]: `Ազգանուն անգլերենով`,
        [Locale.En]: `Last name in English`,
        [Locale.Pt]: 'Sobrenome em inglês',
        [Locale.Ge]: `Last name in English`,
    },
    patronymicInEnglish: {
        [Locale.Ru]: `Отчество на английском`,
        [Locale.Am]: `Հայրանուն անգլերենով`,
        [Locale.En]: `Middle name in English`,
        [Locale.Pt]: 'Nome do meio em inglês',
        [Locale.Ge]: `Middle name in English`,
    },
    nameInArmenian: {
        [Locale.Ru]: `Имя на армянском`,
        [Locale.Am]: `Անուն հայերենով`,
        [Locale.En]: `Name in Armenian`,
        [Locale.Pt]: 'Nome em armênio',
        [Locale.Ge]: `Name in Armenian`,
    },
    lastNameInArmenian: {
        [Locale.Ru]: `Фамилия на армянском`,
        [Locale.Am]: `Ազգանուն հայերենով`,
        [Locale.En]: `Last name in Armenian`,
        [Locale.Pt]: 'Sobrenome em armênio',
        [Locale.Ge]: `Last name in Armenian`,
    },
    oldLastNameInArmenian: {
        [Locale.Ru]: `Старая фамилия на армянском`,
        [Locale.Am]: `Հին ազգանուն հայերենով`,
        [Locale.En]: `Old last name in Armenian`,
        [Locale.Pt]: 'Sobrenome antigo em armênio',
        [Locale.Ge]: `Old last name in Armenian`,
    },
    patronymicInArmenian: {
        [Locale.Ru]: `Отчество на армянском`,
        [Locale.Am]: `Հայրանուն հայերենով`,
        [Locale.En]: `Middle name in Armenian`,
        [Locale.Pt]: 'Nome do meio em armênio',
        [Locale.Ge]: `Middle name in Armenian`,
    },
    nameInGeorgian: {
        [Locale.Ru]: `Имя на грузинском`,
        [Locale.Am]: `Անուն վրացերենով`,
        [Locale.En]: `Name in Georgian`,
        [Locale.Pt]: 'Nome em georgiano',
        [Locale.Ge]: `Name in Georgian`,
    },
    lastNameInGeorgian: {
        [Locale.Ru]: `Фамилия на грузинском`,
        [Locale.Am]: `Ազգանուն վրացերենով`,
        [Locale.En]: `Last name in Georgian`,
        [Locale.Pt]: 'Sobrenome em georgiano',
        [Locale.Ge]: `Last name in Georgian`,
    },
    oldLastNameInGeorgian: {
        [Locale.Ru]: `Старая фамилия на грузинском`,
        [Locale.Am]: `Հին ազգանուն վրացերենով`,
        [Locale.En]: `Old last name in Georgian`,
        [Locale.Pt]: 'Sobrenome antigo em georgiano',
        [Locale.Ge]: `Old last name in Georgian`,
    },
    patronymicInGeorgian: {
        [Locale.Ru]: `Отчество на грузинском`,
        [Locale.Am]: `Հայրանուն վրացերենով`,
        [Locale.En]: `Middle name in Georgian`,
        [Locale.Pt]: 'Nome do meio em georgiano',
        [Locale.Ge]: `Middle name in Georgian`,
    },
    notificationMethod: {
        [Locale.Ru]: `Метод уведомления`,
        [Locale.Am]: `Ծանուցման եղանակ`,
        [Locale.En]: `Notification method`,
        [Locale.Pt]: 'Método de notificação',
        [Locale.Ge]: `Notification method`,
    },
    SNILS: {
        [Locale.Ru]: `СНИЛС`,
        [Locale.Am]: `ՍՆԻԼՍ`,
        [Locale.En]: `SNILS`,
        [Locale.Pt]: 'SNILS',
        [Locale.Ge]: `SNILS`,
    },
    INN: {
        [Locale.Ru]: `ИНН`,
        [Locale.Am]: `ՀՎՀՀ`,
        [Locale.En]: `TIN`,
        [Locale.Pt]: 'ESTANHO',
        [Locale.Ge]: `TIN`,
    },
    seriesDocumentNumber: {
        [Locale.Ru]: `Серия номер документа`,
        [Locale.Am]: `Փաստաթղթի սերիա և համար`,
        [Locale.En]: `Series document number`,
        [Locale.Pt]: 'Número do documento de série',
        [Locale.Ge]: `Series document number`,
    },
    documentType: {
        [Locale.Ru]: `Тип документа`,
        [Locale.Am]: `Փաստաթղթի տեսակ`,
        [Locale.En]: `Document type`,
        [Locale.Pt]: 'Tipo de documento',
        [Locale.Ge]: `Document type`,
    },
    dateOfIssue: {
        [Locale.Ru]: `Дата выдачи`,
        [Locale.Am]: `Տրման ամսաթիվ`,
        [Locale.En]: `Date of issue`,
        [Locale.Pt]: 'Data de emissão',
        [Locale.Ge]: `Date of issue`,
    },
    whoIssued: {
        [Locale.Ru]: `Кто выдал`,
        [Locale.Am]: `Ում կողմից է տրվել`,
        [Locale.En]: `Who issued`,
        [Locale.Pt]: 'Quem emitiu',
        [Locale.Ge]: `Who issued`,
    },
    translit: {
        [Locale.Ru]: `Транслит`,
        [Locale.Am]: `Տառադարձություն`,
        [Locale.En]: `Translit`,
        [Locale.Pt]: 'Transliteração',
        [Locale.Ge]: `Translit`,
    },
    departmentCode: {
        [Locale.Ru]: `Код подразделения`,
        [Locale.Am]: `Ստորաբաժանման կոդ`,
        [Locale.En]: `Department code`,
        [Locale.Pt]: 'Código do departamento',
        [Locale.Ge]: `Department code`,
    },
    foreignPassportNumber: {
        [Locale.Ru]: `Номер заграничного паспорта`,
        [Locale.Am]: `Արտասահմանյան անձնագրի համար`,
        [Locale.En]: `Foreign passport number`,
        [Locale.Pt]: 'Número do passaporte estrangeiro',
        [Locale.Ge]: `Foreign passport number`,
    },
    issuingStateCode: {
        [Locale.Ru]: `Код государства выдачи`,
        [Locale.Am]: `Տրման պետության կոդ`,
        [Locale.En]: `Issuing State Code`,
        [Locale.Pt]: 'Código do Estado Emissor',
        [Locale.Ge]: `Issuing State Code`,
    },
    expirationDateLongText: {
        [Locale.Ru]: `Дата окончания срока действия`,
        [Locale.Am]: `Գործողության ավարտի ամսաթիվ`,
        [Locale.En]: `Expiration date`,
        [Locale.Pt]: 'Data de validade',
        [Locale.Ge]: `Expiration date`,
    },
    registrationAddress: {
        [Locale.Ru]: `Адрес регистрации`,
        [Locale.Am]: `Հաշվառման հասցե`,
        [Locale.En]: `Registration address`,
        [Locale.Pt]: 'Endereço de registro',
        [Locale.Ge]: `Registration address`,
    },
    passportDetailsConfirmed: {
        [Locale.Ru]: `Паспортные данные подтверждены`,
        [Locale.Am]: `Անձնագրային տվյալները հաստատված են`,
        [Locale.En]: `Passport details confirmed`,
        [Locale.Pt]: 'Detalhes do passaporte confirmados',
        [Locale.Ge]: `Passport details confirmed`,
    },
    additionalDataConfirmed: {
        [Locale.Ru]: `Дополнительные данные подтверждены`,
        [Locale.Am]: `Լրացուցիչ տվյալները հաստատված են`,
        [Locale.En]: `Additional data confirmed`,
        [Locale.Pt]: 'Dados adicionais confirmados',
        [Locale.Ge]: `Additional data confirmed`,
    },
    actualAddress: {
        [Locale.Ru]: `Фактический адрес`,
        [Locale.Am]: `Փաստացի հասցե`,
        [Locale.En]: `Actual address`,
        [Locale.Pt]: 'Endereço real',
        [Locale.Ge]: `Actual address`,
    },
    occupation: {
        [Locale.Ru]: `Род деятельности`,
        [Locale.Am]: `Զբաղմունքի տեսակ`,
        [Locale.En]: `Occupation`,
        [Locale.Pt]: 'Ocupação',
        [Locale.Ge]: `Occupation`,
    },
    placeOfWork: {
        [Locale.Ru]: `Место работы`,
        [Locale.Am]: `Աշխատանքի վայր`,
        [Locale.En]: `Place of work`,
        [Locale.Pt]: 'Local de trabalho',
        [Locale.Ge]: `Place of work`,
    },
    commentsOnPayments: {
        [Locale.Ru]: `Комментарий к оплатам`,
        [Locale.Am]: `Մեկնաբանություն վճարումների վերաբերյալ`,
        [Locale.En]: `Comments on payments`,
        [Locale.Pt]: 'Comentários sobre pagamentos',
        [Locale.Ge]: `Comments on payments`,
    },
    commentOnBlocking: {
        [Locale.Ru]: `Комментарий к блокировке`,
        [Locale.Am]: `Մեկնաբանություն արգելափակման վերաբերյալ`,
        [Locale.En]: `Comment on blocking`,
        [Locale.Pt]: 'Comente sobre o bloqueio',
        [Locale.Ge]: `Comment on blocking`,
    },
    placeOfStudy: {
        [Locale.Ru]: `Место учебы`,
        [Locale.Am]: `Ուսման վայր`,
        [Locale.En]: `Place of study`,
        [Locale.Pt]: 'Local de estudo',
        [Locale.Ge]: `Place of study`,
    },
    descriptionOfActivityType: {
        [Locale.Ru]: `Описание рода деятельности`,
        [Locale.Am]: `Զբաղմունքի տեսակի նկարագրություն`,
        [Locale.En]: `Description of the type of activity`,
        [Locale.Pt]: 'Descrição do tipo de atividade',
        [Locale.Ge]: `Description of the type of activity`,
    },
    job: {
        [Locale.Ru]: `Работа`,
        [Locale.Am]: `Աշխատանք`,
        [Locale.En]: `Job`,
        [Locale.Pt]: 'Trabalho',
        [Locale.Ge]: `Job`,
    },
    study: {
        [Locale.Ru]: `Учеба`,
        [Locale.Am]: `Ուսում`,
        [Locale.En]: `Study`,
        [Locale.Pt]: 'Estudar',
        [Locale.Ge]: `Study`,
    },
    other: {
        [Locale.Ru]: `Другое`,
        [Locale.Am]: `Այլ`,
        [Locale.En]: `Other`,
        [Locale.Pt]: 'Outro',
        [Locale.Ge]: `Other`,
    },
    russianPassport: {
        [Locale.Ru]: `Российский паспорт`,
        [Locale.Am]: `Ռուսական անձնագիր`,
        [Locale.En]: `Russian passport`,
        [Locale.Pt]: 'Passaporte russo',
        [Locale.Ge]: `Russian passport`,
    },
    foreignPassport: {
        [Locale.Ru]: `Иностранный паспорт`,
        [Locale.Am]: `Օտարերկրյա անձնագիր`,
        [Locale.En]: `Foreign passport`,
        [Locale.Pt]: 'Passaporte estrangeiro',
        [Locale.Ge]: `Foreign passport`,
    },
    child: {
        [Locale.Ru]: `Ребенок`,
        [Locale.Am]: `Երեխա`,
        [Locale.En]: `Child`,
        [Locale.Pt]: 'Criança',
        [Locale.Ge]: `Child`,
    },
    trustee: {
        [Locale.Ru]: `Попечитель`,
        [Locale.Am]: `Հոգաբարձու`,
        [Locale.En]: `Trustee`,
        [Locale.Pt]: 'Administrador',
        [Locale.Ge]: `Trustee`,
    },
    ehr: {
        [Locale.Ru]: `ЭМК`,
        [Locale.Am]: `ԷԲՔ`,
        [Locale.En]: `EHR`,
        [Locale.Pt]: 'EHR',
        [Locale.Ge]: `EHR`,
    },
    printContract: {
        [Locale.Ru]: `Распечатать договор`,
        [Locale.Am]: `Տպել պայմանագիրը`,
        [Locale.En]: `Print the contract`,
        [Locale.Pt]: 'ato',
        [Locale.Ge]: `Print the contract`,
    },
    uploadFile: {
        [Locale.Ru]: `Загрузить файл`,
        [Locale.Am]: `Վերբեռնել ֆայլ`,
        [Locale.En]: `Upload file`,
        [Locale.Pt]: 'Carregar arquivo',
        [Locale.Ge]: `Upload file`,
    },
    loadingContract: {
        [Locale.Ru]: `Загрузка договора`,
        [Locale.Am]: `Պայմանագրի վերբեռնում`,
        [Locale.En]: `Loading the contract`,
        [Locale.Pt]: 'ato',
        [Locale.Ge]: `Loading the contract`,
    },
    hasDublicateCardMayBe: {
        [Locale.Ru]: `Внимание, возможно, есть дубль карты`,
        [Locale.Am]: `Ուշադրություն, հնարավոր է՝ կա քարտի կրկնօրինակ`,
        [Locale.En]: `Attention, there may be a duplicate card`,
        [Locale.Pt]: 'Atenção, pode haver cartão duplicado',
        [Locale.Ge]: `Attention, there may be a duplicate card`,
    },
    personalInformation: {
        [Locale.Ru]: `Персональные данные`,
        [Locale.Am]: `Անձնական տվյալներ`,
        [Locale.En]: `Personal Information`,
        [Locale.Pt]: 'Informações pessoais',
        [Locale.Ge]: `Personal Information`,
    },
    isPersonalAreaCreated: {
        [Locale.Ru]: `Создан личный кабинет`,
        [Locale.Am]: `Ստեղծվել է անձնական հաշիվ`,
        [Locale.En]: `Personal account created`,
        [Locale.Pt]: 'Conta pessoal criada',
        [Locale.Ge]: `Personal account created`,
    },
    isDocumentsSigned: {
        [Locale.Ru]: `Подписаны первичные документы`,
        [Locale.Am]: `Ստորագրված են առաջնային փաստաթղթերը`,
        [Locale.En]: `Primary documents signed`,
        [Locale.Pt]: 'Documentos primários assinados',
        [Locale.Ge]: `Primary documents signed`,
    },
    sendLinkRegisterPA: {
        [Locale.Ru]: `Отправить ссылку для регистрации ЛК`,
        [Locale.Am]: `Ուղարկել անձնական հաշվի գրանցման հղում`,
        [Locale.En]: `Send a link to register a personal account`,
        [Locale.Pt]: 'Envie um link para registrar uma conta pessoal',
        [Locale.Ge]: `Send a link to register a personal account`,
    },
    sendVerificationCode: {
        [Locale.Ru]: `Отправить код подтверждения`,
        [Locale.Am]: `Ուղարկել հաստատման կոդ`,
        [Locale.En]: `Send verification code`,
        [Locale.Pt]: 'Enviar código de verificação',
        [Locale.Ge]: `Send verification code`,
    },
    files: {
        [Locale.Ru]: `Файлы`,
        [Locale.Am]: `Ֆայլեր`,
        [Locale.En]: `Files`,
        [Locale.Pt]: 'Arquivos',
        [Locale.Ge]: `Files`,
    },
    legalDoc: {
        [Locale.Ru]: `Удостоверяющие документы`,
        [Locale.Am]: `Ինքնությունը հաստատող փաստաթղթեր`,
        [Locale.En]: `Identification documents`,
        [Locale.Pt]: 'Documentos de identificação',
        [Locale.Ge]: `Identification documents`,
    },
    legalDocConfirm: {
        [Locale.Ru]: `Паспортные данные подтверждены`,
        [Locale.Am]: `Անձնագրային տվյալները հաստատված են`,
        [Locale.En]: `Passport details confirmed`,
        [Locale.Pt]: 'Detalhes do passaporte confirmados',
        [Locale.Ge]: `Passport details confirmed`,
    },
    extraDocConfirm: {
        [Locale.Ru]: `Дополнительные данные подтверждены`,
        [Locale.Am]: `Լրացուցիչ տվյալները հաստատված են`,
        [Locale.En]: `Additional data confirmed`,
        [Locale.Pt]: 'Dados adicionais confirmados',
        [Locale.Ge]: `Additional data confirmed`,
    },
    paaportOrBirth: {
        [Locale.Ru]: `Паспорт / Свидетельство о рождении`,
        [Locale.Am]: `Անձնագիր / Ծննդյան վկայական`,
        [Locale.En]: `Passport/Birth Certificate`,
        [Locale.Pt]: 'Passaporte/certidão de nascimento',
        [Locale.Ge]: `Passport/Birth Certificate`,
    },
    internationalPassport: {
        [Locale.Ru]: `Заграничный паспорт`,
        [Locale.Am]: `Արտասահմանյան անձնագիր`,
        [Locale.En]: `International passport`,
        [Locale.Pt]: 'Passaporte internacional',
        [Locale.Ge]: `International passport`,
    },
    legalRepresentative: {
        [Locale.Ru]: `Законный представитель`,
        [Locale.Am]: `Օրինական ներկայացուցիչ`,
        [Locale.En]: `Legal representative`,
        [Locale.Pt]: 'Representante legal',
        [Locale.Ge]: `Legal representative`,
    },
    trustees: {
        [Locale.Ru]: `Доверенные лица`,
        [Locale.Am]: `Վստահված անձինք`,
        [Locale.En]: `Trustees`,
        [Locale.Pt]: 'Curadores',
        [Locale.Ge]: `Trustees`,
    },
    contactFaces: {
        [Locale.Ru]: `Контактные лица`,
        [Locale.Am]: `Կոնտակտային անձինք`,
        [Locale.En]: `Third party contacts`,
        [Locale.Pt]: 'Contatos de terceiros',
        [Locale.Ge]: `Third party contacts`,
    },
    contactDetails: {
        [Locale.Ru]: `Контактные данные`,
        [Locale.Am]: `Կոնտակտային տվյալներ`,
        [Locale.En]: `Contact details`,
        [Locale.Pt]: 'Detalhes de contato',
        [Locale.Ge]: `Contact details`,
    },
    documented: {
        [Locale.Ru]: `Документально подтверждено`,
        [Locale.Am]: `Փաստաթղթերով հաստատված է`,
        [Locale.En]: `Documented`,
        [Locale.Pt]: 'Documentado',
        [Locale.Ge]: `Documented`,
    },
    selectedReferralsAmount: {
        [Locale.Ru]: `Сумма по выбранным направлениям`,
        [Locale.Am]: `Գումար ըստ ընտրված ուղեգրերի`,
        [Locale.En]: `Amount for selected referrals`,
        [Locale.Pt]: 'Valor para referências selecionadas',
        [Locale.Ge]: `Amount for selected referrals`,
    },
    showWithStatus: {
        [Locale.Ru]: `Показать со статусом`,
        [Locale.Am]: `Ցուցադրել կարգավիճակով`,
        [Locale.En]: `Show with status`,
        [Locale.Pt]: 'Mostrar com status',
        [Locale.Ge]: `Show with status`,
    },
    paymentComment: {
        [Locale.Ru]: `Комментарий об оплатах`,
        [Locale.Am]: `Մեկնաբանություն վճարումների մասին`,
        [Locale.En]: `Comment about payments`,
        [Locale.Pt]: 'Comente sobre pagamentos',
        [Locale.Ge]: `Comment about payments`,
    },
    bankCardAttached: {
        [Locale.Ru]: `Прикреплена банковская карта`,
        [Locale.Am]: `Կցված է բանկային քարտ`,
        [Locale.En]: `Bank card attached`,
        [Locale.Pt]: 'Cartão bancário anexado',
        [Locale.Ge]: `Bank card attached`,
    },
    blockPatient: {
        [Locale.Ru]: `Заблокировать пациента`,
        [Locale.Am]: `Արգելափակել պացիենտին`,
        [Locale.En]: `Block patient`,
        [Locale.Pt]: 'Bloquear paciente',
        [Locale.Ge]: `Block patient`,
    },
    blockedBy: {
        [Locale.Ru]: `Карту заблокировал`,
        [Locale.Am]: `Քարտն արգելափակել է`,
        [Locale.En]: `Blocked by`,
        [Locale.Pt]: 'Bloqueado por',
        [Locale.Ge]: `Blocked by`,
    },
    unblock: {
        [Locale.Ru]: `Разблокировать`,
        [Locale.Am]: `Ապաարգելափակել`,
        [Locale.En]: `Unblock`,
        [Locale.Pt]: 'Desbloquear',
        [Locale.Ge]: `Unblock`,
    },
    organizationWitoutContract: {
        [Locale.Ru]: `У организации нет основного контракта. Выберите другую`,
        [Locale.Am]: `Կազմակերպությունը չունի հիմնական պայմանագիր։ Ընտրեք մեկ ուրիշը`,
        [Locale.En]: `The organization does not have a main contract. Choose another`,
        [Locale.Pt]: 'ato',
        [Locale.Ge]: `The organization does not have a main contract. Choose another`,
    },
    entireAllPriceList: {
        [Locale.Ru]: `Включен весь прайс без архивных услуг`,
        [Locale.Am]: `Ներառված է ամբողջ գնացուցակը՝ առանց արխիվային ծառայությունների`,
        [Locale.En]: `The entire price is included without archival services`,
        [Locale.Pt]: 'O preço total está incluído sem serviços de arquivo',
        [Locale.Ge]: `The entire price is included without archival services`,
    },
    provideDetails: {
        [Locale.Ru]: `Опишите подробности, если нужно`,
        [Locale.Am]: `Նկարագրեք մանրամասները, եթե անհրաժեշտ է`,
        [Locale.En]: `Provide details if necessary`,
        [Locale.Pt]: 'Forneça detalhes se necessário',
        [Locale.Ge]: `Provide details if necessary`,
    },
    vaccinationData: {
        [Locale.Ru]: `Данные о вакцинациях`,
        [Locale.Am]: `Պատվաստումների տվյալներ`,
        [Locale.En]: `Vaccination Info`,
        [Locale.Pt]: 'Informações sobre vacinação',
        [Locale.Ge]: `Vaccination Info`,
    },
    vaccineAdministrationDate: {
        [Locale.Ru]: `Дата введения вакцины`,
        [Locale.Am]: `Պատվաստանյութի ներարկման ամսաթիվ`,
        [Locale.En]: `Vaccine administration date`,
        [Locale.Pt]: 'Data de administração da vacina',
        [Locale.Ge]: `Vaccine administration date`,
    },
    area: {
        [Locale.Ru]: `Введение`,
        [Locale.Am]: `Ներարկում`,
        [Locale.En]: `Area`,
        [Locale.Pt]: 'Área',
        [Locale.Ge]: `Area`,
    },
    doctorSignature: {
        [Locale.Ru]: `Подпись и печать доктора`,
        [Locale.Am]: `Բժշկի ստորագրություն և կնիք`,
        [Locale.En]: `Doctor's signature and stamp`,
        [Locale.Pt]: 'Assinatura e carimbo do médico',
        [Locale.Ge]: `Doctor's signature and stamp`,
    },
    printCertificate: {
        [Locale.Ru]: `Распечатать сертификат`,
        [Locale.Am]: `Տպել սերտիֆիկատը`,
        [Locale.En]: `Print certificate`,
        [Locale.Pt]: 'Imprimir certificado',
        [Locale.Ge]: `Print certificate`,
    },
    selectCertificateLanguage: {
        [Locale.Ru]: `Выберите язык сертификата`,
        [Locale.Am]: `Ընտրեք սերտիֆիկատի լեզուն`,
        [Locale.En]: `Select the certificate language`,
        [Locale.Pt]: 'Selecione o idioma do certificado',
        [Locale.Ge]: `Select the certificate language`,
    },
    vaccinationCertificateDated: {
        [Locale.Ru]: `Сертификат вакцинаций от`,
        [Locale.Am]: `Պատվաստումների սերտիֆիկատ՝`,
        [Locale.En]: `Vaccination certificate dated`,
        [Locale.Pt]: 'Certificado de vacinação de',
        [Locale.Ge]: `Vaccination certificate dated`,
    },
    vaccinationDate: {
        [Locale.Ru]: `Дата вакцинации`,
        [Locale.Am]: `Ամսաթիվ`,
        [Locale.En]: `Immunization date`,
        [Locale.Pt]: 'Data da vacinação',
        [Locale.Ge]: `Immunization date`,
    },
    doseShort: {
        [Locale.Ru]: `Доза`,
        [Locale.Am]: `Դոզ.`,
        [Locale.En]: `Dose`,
        [Locale.Pt]: 'Dose',
        [Locale.Ge]: `Dose`,
    },
    series: {
        [Locale.Ru]: `Серия`,
        [Locale.Am]: `Սերիա`,
        [Locale.En]: `Serial Number`,
        [Locale.Pt]: 'Número de série',
        [Locale.Ge]: `Serial Number`,
    },
    expiryDate: {
        [Locale.Ru]: `Срок годности`,
        [Locale.Am]: `Ժամկետ`,
        [Locale.En]: `Expiry date`,
        [Locale.Pt]: 'Data de validade',
        [Locale.Ge]: `Expiry date`,
    },
    vaccine: {
        [Locale.Ru]: `Препарат`,
        [Locale.Am]: `Պրեպարատ`,
        [Locale.En]: `Vaccine`,
        [Locale.Pt]: 'Medicamento',
        [Locale.Ge]: `Vaccine`,
    },
    intramuscularShort: {
        [Locale.Ru]: `в/м`,
        [Locale.Am]: `IM`,
        [Locale.En]: `IM`,
        [Locale.Pt]: 'IM',
        [Locale.Ge]: `IM`,
    },
    hypodermalShort: {
        [Locale.Ru]: `п/к`,
        [Locale.Am]: `SC`,
        [Locale.En]: `SC`,
        [Locale.Pt]: 'SC',
        [Locale.Ge]: `SC`,
    },
    intradermalShort: {
        [Locale.Ru]: `в/к`,
        [Locale.Am]: `ID`,
        [Locale.En]: `ID`,
        [Locale.Pt]: 'ID',
        [Locale.Ge]: `ID`,
    },
    oralShort: {
        [Locale.Ru]: `п/о`,
        [Locale.Am]: `PO`,
        [Locale.En]: `PO`,
        [Locale.Pt]: 'PO',
        [Locale.Ge]: `PO`,
    },
    aerosolShort: {
        [Locale.Ru]: `а/з`,
        [Locale.Am]: `INH`,
        [Locale.En]: `INH`,
        [Locale.Pt]: 'INH',
        [Locale.Ge]: `INH`,
    },
    documents: {
        [Locale.Ru]: `Вложения`,
        [Locale.Am]: `Կցորդներ`,
        [Locale.En]: `Documents`,
        [Locale.Pt]: 'Documentos',
        [Locale.Ge]: `Documents`,
    },
    entryEhr: {
        [Locale.Ru]: `Запись в ЭМК`,
        [Locale.Am]: `Գրառում ԷԲՔ-ում`,
        [Locale.En]: `Entry in the EHR`,
        [Locale.Pt]: 'Entrada não EHR',
        [Locale.Ge]: `Entry in the EHR`,
    },
    episodeNotScheduled: {
        [Locale.Ru]: `Эпизод не назначен`,
        [Locale.Am]: `Էպիզոդ նշանակված չէ`,
        [Locale.En]: `Episode not scheduled`,
        [Locale.Pt]: 'Episódio não agendado',
        [Locale.Ge]: `Episode not scheduled`,
    },
    executedReferrals: {
        [Locale.Ru]: `Ответы на направления`,
        [Locale.Am]: `Պատասխաններ ուղեգրերին`,
        [Locale.En]: `Executed referrals`,
        [Locale.Pt]: 'Referências executadas',
        [Locale.Ge]: `Executed referrals`,
    },
    youAnsweredOtherReferral: {
        [Locale.Ru]: `Вы ответили на направление не принадлежащее ни одному из эпизодов.
При создании и  ли прикреплении эпизода этот ответ будет прикреплен к нему`,
        [Locale.Am]: `Դուք պատասխանել եք ուղեգրի, որը չի պատկանում որևէ էպիզոդի։
Էպիզոդ ստեղծելիս կամ կցելիս այս պատասխանը կկցվի դրան`,
        [Locale.En]: `You answered a referral that does not belong to any of the episodes.
When you create or attach an episode, this answer will be attached to it`,
        [Locale.Pt]: `Respondeu a uma solicitação que não pertence a nenhum dos episódios.
Ao criar ou anexar um episódio, esta resposta será anexada ao mesmo.`,
        [Locale.Ge]: `You answered a referral that does not belong to any of the episodes.
When you create or attach an episode, this answer will be attached to it`,
    },
    documentSignedByECP: {
        [Locale.Ru]: `Документ подписан усиленной квалифицированной электронной подписью`,
        [Locale.Am]: `Փաստաթուղթը ստորագրված է ուժեղացված որակավորված էլեկտրոնային ստորագրությամբ`,
        [Locale.En]: `The document is signed with an enhanced qualified electronic signature`,
        [Locale.Pt]: 'O documento é assinado com uma assinatura eletrônica qualificada aprimorada',
        [Locale.Ge]: `The document is signed with an enhanced qualified electronic signature`,
    },
    certificate: {
        [Locale.Ru]: `Сертификат`,
        [Locale.Am]: `Սերտիֆիկատ`,
        [Locale.En]: `Certificate`,
        [Locale.Pt]: 'Certificado',
        [Locale.Ge]: `Certificate`,
    },
    attachedFiles: {
        [Locale.Ru]: `Прикрепленные файлы`,
        [Locale.Am]: `Կցված ֆայլեր`,
        [Locale.En]: `Attached files`,
        [Locale.Pt]: 'Arquivos anexados',
        [Locale.Ge]: `Attached files`,
    },
    stampLoadingError: {
        [Locale.Ru]: `При загрузке печати произошла ошибка`,
        [Locale.Am]: `Կնիքը վերբեռնելիս առաջացել է սխալ`,
        [Locale.En]: `Stamp loading error`,
        [Locale.Pt]: 'Erro ao carregar carimbo',
        [Locale.Ge]: `Stamp loading error`,
    },
    downloadFile: {
        [Locale.Ru]: `Скачать файл`,
        [Locale.Am]: `Ներբեռնել ֆայլը`,
        [Locale.En]: `Download file`,
        [Locale.Pt]: 'Baixar arquivo',
        [Locale.Ge]: `Download file`,
    },
    viewAll: {
        [Locale.Ru]: `Посмотреть все`,
        [Locale.Am]: `Դիտել բոլորը`,
        [Locale.En]: `View all`,
        [Locale.Pt]: 'Ver tudo',
        [Locale.Ge]: `View all`,
    },
    downloadAll: {
        [Locale.Ru]: `Скачать все`,
        [Locale.Am]: `Ներբեռնել բոլորը`,
        [Locale.En]: `Download all`,
        [Locale.Pt]: 'Baixar tudo',
        [Locale.Ge]: `Download all`,
    },
    entryArchiveExport: {
        [Locale.Ru]: `Выгрузить все файлы`,
        [Locale.Am]: `Ներբեռնել բոլոր ֆայլերը`,
        [Locale.En]: `Download all files`,
        [Locale.Pt]: 'Baixar todos os arquivos',
        [Locale.Ge]: `ყველა ფაილის ჩამოტვირთვა`,
    },
    entryArchiveFileName: {
        [Locale.Ru]: `Файлы пациента`,
        [Locale.Am]: `Հիվանդի ֆայլերը`,
        [Locale.En]: `Patient files`,
        [Locale.Pt]: 'Arquivos do paciente',
        [Locale.Ge]: `პაციენტის ფაილები`,
    },
    entryArchiveExportInProgress: {
        [Locale.Ru]: `Готовим архив…`,
        [Locale.Am]: `Արխիվը պատրաստվում է…`,
        [Locale.En]: `Preparing archive…`,
        [Locale.Pt]: 'Preparando o arquivo…',
        [Locale.Ge]: `არქივი მზადდება…`,
    },
    entryArchiveExportError: {
        [Locale.Ru]: `Не удалось выгрузить файлы`,
        [Locale.Am]: `Չհաջողվեց ներբեռնել ֆայլերը`,
        [Locale.En]: `Failed to download files`,
        [Locale.Pt]: 'Não foi possível baixar os arquivos',
        [Locale.Ge]: `ფაილების ჩამოტვირთვა ვერ მოხერხდა`,
    },
    entryArchiveExportTimeout: {
        [Locale.Ru]: `Выгрузка занимает слишком много времени, попробуйте позже`,
        [Locale.Am]: `Ներբեռնումը չափազանց երկար է տևում, փորձեք ավելի ուշ`,
        [Locale.En]: `Download is taking too long, try again later`,
        [Locale.Pt]: 'O download está demorando muito, tente novamente mais tarde',
        [Locale.Ge]: `ჩამოტვირთვა ძალიან დიდხანს გრძელდება, სცადეთ მოგვიანებით`,
    },
    sendEntryByEmail: {
        [Locale.Ru]: `Отправить запись на почту`,
        [Locale.Am]: `Ուղարկել գրառումը էլ. փոստով`,
        [Locale.En]: `Send entry by email`,
        [Locale.Pt]: 'Enviar entrada por e-mail',
        [Locale.Ge]: `Send entry by email`,
    },
    addAnotherDiagnosis: {
        [Locale.Ru]: `Добавить ещё один диагноз`,
        [Locale.Am]: `Ավելացնել ևս մեկ ախտորոշում`,
        [Locale.En]: `Add another diagnosis`,
        [Locale.Pt]: 'Adicionar outro diagnóstico',
        [Locale.Ge]: `Add another diagnosis`,
    },
    openCases: {
        [Locale.Ru]: `Открытые случаи`,
        [Locale.Am]: `Բաց դեպքեր`,
        [Locale.En]: `Open cases`,
        [Locale.Pt]: 'Casos abertos',
        [Locale.Ge]: `Open cases`,
    },
    noMedicationsYet: {
        [Locale.Ru]: `В этой записи еще нет медикаментов`,
        [Locale.Am]: `Այս գրառման մեջ դեռ դեղամիջոցներ չկան`,
        [Locale.En]: `There are no medications in this entry yet`,
        [Locale.Pt]: 'Ainda não há medicamentos nesta entrada',
        [Locale.Ge]: `There are no medications in this entry yet`,
    },
    addMedication: {
        [Locale.Ru]: `Добавить медикамент`,
        [Locale.Am]: `Ավելացնել դեղամիջոց`,
        [Locale.En]: `Add medication`,
        [Locale.Pt]: 'Adicionar medicamento',
        [Locale.Ge]: `Add medication`,
    },
    medicinesTaken: {
        [Locale.Ru]: `Принимаемые медикаменты`,
        [Locale.Am]: `Ընդունվող դեղամիջոցներ`,
        [Locale.En]: `Medicines taken`,
        [Locale.Pt]: 'Medicamentos tomados',
        [Locale.Ge]: `Medicines taken`,
    },
    doesNotTakeMedicinesRegularly: {
        [Locale.Ru]: `Не принимает медикаменты регулярно`,
        [Locale.Am]: `Կանոնավոր դեղամիջոցներ չի ընդունում`,
        [Locale.En]: `Does not take medicines regularly`,
        [Locale.Pt]: 'Não toma remédios regularmente',
        [Locale.Ge]: `Does not take medicines regularly`,
    },
    ophthalmometry: {
        [Locale.Ru]: `Офтальмометрия`,
        [Locale.Am]: `Օֆթալմոմետրիա`,
        [Locale.En]: `Ophthalmometry`,
        [Locale.Pt]: 'Oftalmometria',
        [Locale.Ge]: `Ophthalmometry`,
    },
    nonContactTonometry: {
        [Locale.Ru]: `Бесконтактная тонометрия`,
        [Locale.Am]: `Ոչ կոնտակտային տոնոմետրիա`,
        [Locale.En]: `Non-contact tonometry`,
        [Locale.Pt]: 'Tonometria sem contato',
        [Locale.Ge]: `Non-contact tonometry`,
    },
    maklakovTonometry: {
        [Locale.Ru]: `Тонометрия по Маклакову`,
        [Locale.Am]: `Տոնոմետրիա ըստ Մակլակովի`,
        [Locale.En]: `Tonometry according to Maklakov`,
        [Locale.Pt]: 'Tonometria de acordo com Maklakov',
        [Locale.Ge]: `Tonometry according to Maklakov`,
    },
    glassSelect: {
        [Locale.Ru]: `Подбор очков`,
        [Locale.Am]: `Ակնոցների ընտրություն`,
        [Locale.En]: `Selection of glasses`,
        [Locale.Pt]: 'Seleção de óculos',
        [Locale.Ge]: `Selection of glasses`,
    },
    noReferralBeenChosen: {
        [Locale.Ru]: `Ни одно направление не выбрано. Выберите нужное направление`,
        [Locale.Am]: `Ոչ մի ուղեգիր ընտրված չէ։ Ընտրեք անհրաժեշտ ուղեգիրը`,
        [Locale.En]: `No referral has been chosen. Choose the right referral`,
        [Locale.Pt]: 'Nenhuma referência foi escolhida. Escolha a referência certa',
        [Locale.Ge]: `No referral has been chosen. Choose the right referral`,
    },
    actualReferral: {
        [Locale.Ru]: `Актуальные направления`,
        [Locale.Am]: `Արդիական ուղեգրեր`,
        [Locale.En]: `Actual referral`,
        [Locale.Pt]: 'Referência real',
        [Locale.Ge]: `Actual referral`,
    },
    noServiceInEntryYet: {
        [Locale.Ru]: `В этой записи еще нет услуг`,
        [Locale.Am]: `Այս գրառման մեջ դեռ ծառայություններ չկան`,
        [Locale.En]: `There are no services in this entry yet`,
        [Locale.Pt]: 'Ainda não há serviços nesta entrada',
        [Locale.Ge]: `There are no services in this entry yet`,
    },
    noMaterialInEntryYet: {
        [Locale.Ru]: `Вы не добавляли материалы и расходы`,
        [Locale.Am]: `Դուք չեք ավելացրել նյութեր և ծախսեր`,
        [Locale.En]: `You have not added materials and expenses`,
        [Locale.Pt]: 'Você não adicionou materiais e despesas',
        [Locale.Ge]: `You have not added materials and expenses`,
    },
    removeMaterial: {
        [Locale.Ru]: `Удалить материал`,
        [Locale.Am]: `Ջնջել նյութը`,
        [Locale.En]: `Remove material`,
        [Locale.Pt]: 'Material removedor',
        [Locale.Ge]: `Remove material`,
    },
    materialsCostIsNotCharged: {
        [Locale.Ru]: `Стоимость использованных материалов и других расходов не выставляется в счёт пациенту`,
        [Locale.Am]: `Օգտագործված նյութերի և այլ ծախսերի արժեքը պացիենտին հաշիվ չի ներկայացվում`,
        [Locale.En]: `The cost of materials used and other expenses are not billed to the patient`,
        [Locale.Pt]: 'O custo dos materiais utilizados e demais despesas não são cobrados do paciente',
        [Locale.Ge]: `The cost of materials used and other expenses are not billed to the patient`,
    },
    byInsurance: {
        [Locale.Ru]: `По страховой программе`,
        [Locale.Am]: `Ըստ ապահովագրական ծրագրի`,
        [Locale.En]: `According to the insurance program`,
        [Locale.Pt]: 'De acordo com o programa de seguro',
        [Locale.Ge]: `According to the insurance program`,
    },
    byGp: {
        [Locale.Ru]: `По гарантийному письму`,
        [Locale.Am]: `Ըստ երաշխիքային նամակի`,
        [Locale.En]: `According to the letter of guarantee`,
        [Locale.Pt]: 'De acordo com a carta de garantia',
        [Locale.Ge]: `According to the letter of guarantee`,
    },
    individualDiscount: {
        [Locale.Ru]: `Индивидуальная скидка`,
        [Locale.Am]: `Անհատական զեղչ`,
        [Locale.En]: `Individual discount`,
        [Locale.Pt]: 'Desconto individual',
        [Locale.Ge]: `Individual discount`,
    },
    byChangeBaseDiscount: {
        [Locale.Ru]: `Скидка за счет изменения базовой цены`,
        [Locale.Am]: `Զեղչ բազային գնի փոփոխման հաշվին`,
        [Locale.En]: `Discount due to change in base price`,
        [Locale.Pt]: 'Desconto devido a alteração no preço base',
        [Locale.Ge]: `Discount due to change in base price`,
    },
    newRenderedService: {
        [Locale.Ru]: `Новая услуга`,
        [Locale.Am]: `Նոր ծառայություն`,
        [Locale.En]: `New rendered service`,
        [Locale.Pt]: 'Novo serviço prestado',
        [Locale.Ge]: `New rendered service`,
    },
    materialsUsed: {
        [Locale.Ru]: `Материалы и другие расходы`,
        [Locale.Am]: `Նյութեր և այլ ծախսեր`,
        [Locale.En]: `Materials and other expenses`,
        [Locale.Pt]: 'Materiais e outras despesas',
        [Locale.Ge]: `Materials and other expenses`,
    },
    fillAllTranslations: {
        [Locale.Ru]: `Заполните все поля перевода`,
        [Locale.Am]: `Լրացրեք թարգմանության բոլոր դաշտերը`,
        [Locale.En]: `Fill in all translation fields`,
        [Locale.Pt]: 'Preencha todos os campos de tradução',
        [Locale.Ge]: `Fill in all translation fields`,
    },
    entryMustSinged: {
        [Locale.Ru]: `Запись должна быть подписана`,
        [Locale.Am]: `Գրառումը պետք է ստորագրված լինի`,
        [Locale.En]: `The entry must be signed`,
        [Locale.Pt]: 'A entrada deve ser assinada',
        [Locale.Ge]: `The entry must be signed`,
    },
    untranslatedFieldsList: {
        [Locale.Ru]: `Не переведены поля:`,
        [Locale.Am]: `Չթարգմանված դաշտեր՝`,
        [Locale.En]: `Untranslated fields:`,
        [Locale.Pt]: 'Campos não traduzidos:',
        [Locale.Ge]: `Untranslated fields:`,
    },
    untitledField: {
        [Locale.Ru]: `Поле без названия`,
        [Locale.Am]: `Անանուն դաշտ`,
        [Locale.En]: `Untitled field`,
        [Locale.Pt]: 'Campo sem nome',
        [Locale.Ge]: `Untitled field`,
    },
    confirmTranslation: {
        [Locale.Ru]: `Подтвердить перевод`,
        [Locale.Am]: `Հաստատել թարգմանությունը`,
        [Locale.En]: `Confirm translation`,
        [Locale.Pt]: 'Confirmar tradução',
        [Locale.Ge]: `Confirm translation`,
    },
    translationTo: {
        [Locale.Ru]: `Перевод на`,
        [Locale.Am]: `Թարգմանություն՝`,
        [Locale.En]: `Translation to`,
        [Locale.Pt]: 'Tradução para',
        [Locale.Ge]: `Translation to`,
    },
    translate: {
        [Locale.Ru]: `Перевести`,
        [Locale.Am]: `Թարգմանել`,
        [Locale.En]: `Translate`,
        [Locale.Pt]: 'Traduzir',
        [Locale.Ge]: `Translate`,
    },
    uiTranslate: {
        [Locale.Ru]: `Переводы интерфейса`,
        [Locale.Am]: `Ինտերֆեյսի թարգմանություններ`,
        [Locale.En]: `Interface translations`,
        [Locale.Pt]: 'Traduções de interface',
        [Locale.Ge]: `ინტერფეისის თარგმანები`,
    },
    addTranslation: {
        [Locale.Ru]: `Добавить перевод`,
        [Locale.Am]: `Ավելացնել թարգմանություն`,
        [Locale.En]: `Add translation`,
        [Locale.Pt]: 'Adicionar tradução',
        [Locale.Ge]: `Add translation`,
    },
    textWasTranslatedAutomatically: {
        [Locale.Ru]: 'Текст был переведен автоматически',
        [Locale.Am]: 'Տեքստը թարգմանվել է ավտոմատ',
        [Locale.En]: 'The text was automatically translated',
        [Locale.Pt]: 'O texto foi traduzido automaticamente',
        [Locale.Ge]: 'The text was automatically translated',
    },
    updateAutoTranslate: {
        [Locale.Ru]: `Обновить авто перевод`,
        [Locale.Am]: `Թարմացնել ավտոմատ թարգմանությունը`,
        [Locale.En]: `Update automatic translation`,
        [Locale.Pt]: 'Atualizar tradução automática',
        [Locale.Ge]: `Update automatic translation`,
    },
    editGroupForField: {
        [Locale.Ru]: `Редактирование группы для поля`,
        [Locale.Am]: `Դաշտի խմբի խմբագրում`,
        [Locale.En]: `Editing a group for a field`,
        [Locale.Pt]: 'Editando um grupo para um campo',
        [Locale.Ge]: `Editing a group for a field`,
    },
    subgroupName: {
        [Locale.Ru]: `Название подгруппы`,
        [Locale.Am]: `Ենթախմբի անվանում`,
        [Locale.En]: `Subgroup name`,
        [Locale.Pt]: 'Nome do subgrupo',
        [Locale.Ge]: `Subgroup name`,
    },
    groupName: {
        [Locale.Ru]: `Название группы`,
        [Locale.Am]: `Խմբի անվանում`,
        [Locale.En]: `Group name`,
        [Locale.Pt]: 'Nome do grupo',
        [Locale.Ge]: `Group name`,
    },
    deleteSubgroup: {
        [Locale.Ru]: `Удалить подгруппу`,
        [Locale.Am]: `Ջնջել ենթախումբը`,
        [Locale.En]: `Delete subgroup`,
        [Locale.Pt]: 'Excluir subgrupo',
        [Locale.Ge]: `Delete subgroup`,
    },
    deleteGroup: {
        [Locale.Ru]: `Удалить группу`,
        [Locale.Am]: `Ջնջել խումբը`,
        [Locale.En]: `Delete Group`,
        [Locale.Pt]: 'Excluir grupo',
        [Locale.Ge]: `Delete Group`,
    },
    editFieldTemplate: {
        [Locale.Ru]: `Редактирование шаблона для поля`,
        [Locale.Am]: `Դաշտի ձևանմուշի խմբագրում`,
        [Locale.En]: `Editing a field template`,
        [Locale.Pt]: 'Editando um modelo de campo',
        [Locale.Ge]: `Editing a field template`,
    },
    getEpisode: {
        [Locale.Ru]: `Взять эпизод себе`,
        [Locale.Am]: `Վերցնել էպիզոդն ինձ`,
        [Locale.En]: `Get the episode for yourself`,
        [Locale.Pt]: 'Obtenha o episódio para você',
        [Locale.Ge]: `Get the episode for yourself`,
    },
    mergeEhr: {
        [Locale.Ru]: `Объединение ЭМК`,
        [Locale.Am]: `ԷԲՔ-ների միավորում`,
        [Locale.En]: `Merge ehr`,
        [Locale.Pt]: 'Mesclar ehr',
        [Locale.Ge]: `Merge ehr`,
    },
    selectMainEhr: {
        [Locale.Ru]: `Выберите главную карту`,
        [Locale.Am]: `Ընտրեք հիմնական քարտը`,
        [Locale.En]: `Select main ehr`,
        [Locale.Pt]: 'Selecione ehr principal',
        [Locale.Ge]: `Select main ehr`,
    },
    selectCorrectFields: {
        [Locale.Ru]: `Выберите поля с верной информацией`,
        [Locale.Am]: `Ընտրեք ճիշտ տեղեկությամբ դաշտերը`,
        [Locale.En]: `Select fields with correct information`,
        [Locale.Pt]: 'Selecione os campos com informações corretas',
        [Locale.Ge]: `Select fields with correct information`,
    },
    creatingNewEntry: {
        [Locale.Ru]: `Создание новой записи ЭМК`,
        [Locale.Am]: `ԷԲՔ-ի նոր գրառման ստեղծում`,
        [Locale.En]: `Creating a new EHR record`,
        [Locale.Pt]: 'Criando um novo registro EHR',
        [Locale.Ge]: `Creating a new EHR record`,
    },
    selectReservation: {
        [Locale.Ru]: `Выберите бронь для создания записи`,
        [Locale.Am]: `Ընտրեք ամրագրումը գրառում ստեղծելու համար`,
        [Locale.En]: `Select a reservation to create an entry`,
        [Locale.Pt]: 'Selecione uma reserva para criar uma entrada',
        [Locale.Ge]: `Select a reservation to create an entry`,
    },
    patientList: {
        [Locale.Ru]: `Список пациентов`,
        [Locale.Am]: `Պացիենտների ցանկ`,
        [Locale.En]: `Patient list`,
        [Locale.Pt]: 'Lista de pacientes',
        [Locale.Ge]: `Patient list`,
    },
    topUpAccount: {
        [Locale.Ru]: `Пополнить счет`,
        [Locale.Am]: `Համալրել հաշիվը`,
        [Locale.En]: `Top up your account`,
        [Locale.Pt]: 'Recarregue sua conta',
        [Locale.Ge]: `Top up your account`,
    },
    debitAccount: {
        [Locale.Ru]: `Списать со счета`,
        [Locale.Am]: `Դուրս գրել հաշվից`,
        [Locale.En]: `Debit the account`,
        [Locale.Pt]: 'Débito da conta',
        [Locale.Ge]: `Debit the account`,
    },
    printCoverPage: {
        [Locale.Ru]: `Распечатать титульный лист`,
        [Locale.Am]: `Տպել տիտղոսաթերթը`,
        [Locale.En]: `Print cover page`,
        [Locale.Pt]: 'Imprimir página de rosto',
        [Locale.Ge]: `Print cover page`,
    },
    printA200: {
        [Locale.Ru]: `Распечатать форму 200A`,
        [Locale.Am]: `Տպել 200A ձևը`,
        [Locale.En]: `Print Form 200A`,
        [Locale.Pt]: 'Imprimir Formulário 200A',
        [Locale.Ge]: `Print Form 200A`,
    },
    addEntry: {
        [Locale.Ru]: `Добавить запись`,
        [Locale.Am]: `Ավելացնել գրառում`,
        [Locale.En]: `Add entry`,
        [Locale.Pt]: 'Adicionar entrada',
        [Locale.Ge]: `Add entry`,
    },
    clearElastic: {
        [Locale.Ru]: `Почистить записи в эластике`,
        [Locale.Am]: `Մաքրել գրառումները էլաստիկում`,
        [Locale.En]: `Clear records in elastic`,
        [Locale.Pt]: 'Limpar registros no elástico',
        [Locale.Ge]: `Clear records in elastic`,
    },
    futureReservations: {
        [Locale.Ru]: `Будущие приемы`,
        [Locale.Am]: `Ապագա ընդունելություններ`,
        [Locale.En]: `Future reservations`,
        [Locale.Pt]: 'Reservas futuras',
        [Locale.Ge]: `Future reservations`,
    },
    futureMany: {
        [Locale.Ru]: `Будущие`,
        [Locale.Am]: `Ապագա`,
        [Locale.En]: `Future`,
        [Locale.Pt]: 'Futuro',
        [Locale.Ge]: `Future`,
    },
    paymentDate: {
        [Locale.Ru]: `Дата оплаты`,
        [Locale.Am]: `Վճարման ամսաթիվ`,
        [Locale.En]: `Payment date`,
        [Locale.Pt]: 'Data de pagamento',
        [Locale.Ge]: `Payment date`,
    },
    unknownMethod: {
        [Locale.Ru]: `Неизвестный метод`,
        [Locale.Am]: `Անհայտ եղանակ`,
        [Locale.En]: `Unknown method`,
        [Locale.Pt]: 'Método desconhecido',
        [Locale.Ge]: `Unknown method`,
    },
    unknownStatus: {
        [Locale.Ru]: `Неизвестный статус`,
        [Locale.Am]: `Անհայտ կարգավիճակ`,
        [Locale.En]: `Unknown status`,
        [Locale.Pt]: 'Estado desconhecido',
        [Locale.Ge]: `Unknown status`,
    },
    tryPaymentAgain: {
        [Locale.Ru]: `Повторить попытку оплаты`,
        [Locale.Am]: `Կրկնել վճարման փորձը`,
        [Locale.En]: `Try payment again`,
        [Locale.Pt]: 'Tente pagar novamente',
        [Locale.Ge]: `Try payment again`,
    },
    preparationError: {
        [Locale.Ru]: `Ошибка подготовки`,
        [Locale.Am]: `Նախապատրաստման սխալ`,
        [Locale.En]: `Preparation error`,
        [Locale.Pt]: 'Erro de preparação',
        [Locale.Ge]: `Preparation error`,
    },
    chooseRepresentative: {
        [Locale.Ru]: `Выберите законного представителя`,
        [Locale.Am]: `Ընտրեք օրինական ներկայացուցչին`,
        [Locale.En]: `Choose a legal representative`,
        [Locale.Pt]: 'Escolha um representante legal',
        [Locale.Ge]: `Choose a legal representative`,
    },
    requiredField: {
        [Locale.Ru]: `Обязательное поле`,
        [Locale.Am]: `Պարտադիր դաշտ`,
        [Locale.En]: `Required field`,
        [Locale.Pt]: `Campo obrigatório`,
        [Locale.Ge]: `Required field`,
    },
    invalidName: {
        [Locale.Ru]: `Невалидное имя`,
        [Locale.Am]: `Անվավեր անուն`,
        [Locale.En]: `Invalid name`,
        [Locale.Pt]: 'Nome inválido',
        [Locale.Ge]: `Invalid name`,
    },
    relationshipType: {
        [Locale.Ru]: `Вид родства`,
        [Locale.Am]: `Ազգակցական կապի տեսակ`,
        [Locale.En]: `Type of relationship`,
        [Locale.Pt]: 'Tipo de relacionamento',
        [Locale.Ge]: `Type of relationship`,
    },
    createEhr: {
        [Locale.Ru]: `Создать карту`,
        [Locale.Am]: `Ստեղծել քարտ`,
        [Locale.En]: `Create ehr`,
        [Locale.Pt]: 'Criar ehr',
        [Locale.Ge]: `Create ehr`,
    },
    whoPays: {
        [Locale.Ru]: `Кто оплачивает`,
        [Locale.Am]: `Ով է վճարում`,
        [Locale.En]: `Who pays`,
        [Locale.Pt]: 'Quem paga',
        [Locale.Ge]: `Who pays`,
    },
    hasReservations: {
        [Locale.Ru]: `Есть  бронь`,
        [Locale.Am]: `Կա  ամրագրում`,
        [Locale.En]: `Has reservation`,
        [Locale.Pt]: 'Tem reserva',
        [Locale.Ge]: `Has reservation`,
    },
    IC: {
        [Locale.Ru]: `СК`,
        [Locale.Am]: `ԱԸ`,
        [Locale.En]: `IC`,
        [Locale.Pt]: 'IC',
        [Locale.Ge]: `IC`,
    },
    ICGP: {
        [Locale.Ru]: `СК/ГП`,
        [Locale.Am]: `ԱԸ/ԵՆ`,
        [Locale.En]: `IC/GP`,
        [Locale.Pt]: 'CI/GP',
        [Locale.Ge]: `IC/GP`,
    },
    paymentHistory: {
        [Locale.Ru]: `История оплат`,
        [Locale.Am]: `Վճարումների պատմություն`,
        [Locale.En]: `Payment history`,
        [Locale.Pt]: 'Histórico de pagamentos',
        [Locale.Ge]: `Payment history`,
    },
    patientCantWithDebtText: {
        [Locale.Ru]: `Пациент не сможет записываться на приём в наших клиниках и просматривать свою медкарту, пока не оплатит долг`,
        [Locale.Am]: `Պացիենտը չի կարողանա գրանցվել ընդունելության մեր կլինիկաներում և դիտել իր բժշկական քարտը, քանի դեռ չի մարել պարտքը`,
        [Locale.En]: `The patient will not be able to make an appointment in our clinics or view his medical record until he pays the debt`,
        [Locale.Pt]: 'O paciente não poderá marcar consulta em nossas clínicas ou visualizar seu prontuário até pagar a dívida',
        [Locale.Ge]: `The patient will not be able to make an appointment in our clinics or view his medical record until he pays the debt`,
    },
    describeDetailWithPatient: {
        [Locale.Ru]: `Опишите подробности последних договоренностей с пациентом`,
        [Locale.Am]: `Նկարագրեք պացիենտի հետ վերջին պայմանավորվածությունների մանրամասները`,
        [Locale.En]: `Describe details of recent arrangements with the patient.`,
        [Locale.Pt]: 'Descreva detalhes de acordos recentes com o paciente.',
        [Locale.Ge]: `Describe details of recent arrangements with the patient.`,
    },
    sumOfSelected: {
        [Locale.Ru]: `Сумма выбранных`,
        [Locale.Am]: `Ընտրվածների գումարը`,
        [Locale.En]: `Sum selected`,
        [Locale.Pt]: 'Soma selecionada',
        [Locale.Ge]: `Sum selected`,
    },
    addNewGp: {
        [Locale.Ru]: `Добавить новое ГП`,
        [Locale.Am]: `Ավելացնել նոր երաշխիքային նամակ`,
        [Locale.En]: `Add new GP`,
        [Locale.Pt]: 'Adicionar novo GP',
        [Locale.Ge]: `Add new GP`,
    },
    newGp: {
        [Locale.Ru]: `Новое ГП`,
        [Locale.Am]: `Նոր երաշխիքային նամակ`,
        [Locale.En]: `New GP`,
        [Locale.Pt]: 'Novo GP',
        [Locale.Ge]: `New GP`,
    },
    changeAttachment: {
        [Locale.Ru]: `Изменить прикрепление`,
        [Locale.Am]: `Փոփոխել կցումը`,
        [Locale.En]: `Change Attachment`,
        [Locale.Pt]: 'Alterar anexo',
        [Locale.Ge]: `Change Attachment`,
    },
    failedCreateSubscription: {
        [Locale.Ru]: `Не удалось создать подписку`,
        [Locale.Am]: `Չհաջողվեց ստեղծել բաժանորդագրություն`,
        [Locale.En]: `Failed to create subscription`,
        [Locale.Pt]: 'Falha ao criar assinatura',
        [Locale.Ge]: `Failed to create subscription`,
    },
    failedAddSubscription: {
        [Locale.Ru]: `Не удалось добавить подписку`,
        [Locale.Am]: `Չհաջողվեց ավելացնել բաժանորդագրություն`,
        [Locale.En]: `Failed to add subscription`,
        [Locale.Pt]: 'Falha ao adicionar assinatura',
        [Locale.Ge]: `Failed to add subscription`,
    },
    failedUpdateSubscription: {
        [Locale.Ru]: `Не удалось обновить подписку`,
        [Locale.Am]: `Չհաջողվեց թարմացնել բաժանորդագրությունը`,
        [Locale.En]: `Failed to update subscription`,
        [Locale.Pt]: 'Falha ao atualizar assinatura',
        [Locale.Ge]: `Failed to update subscription`,
    },
    selectProgramFirst: {
        [Locale.Ru]: `Сначала выберите программу`,
        [Locale.Am]: `Նախ ընտրեք ծրագիրը`,
        [Locale.En]: `First select a program`,
        [Locale.Pt]: 'Primeiro selecione um programa',
        [Locale.Ge]: `First select a program`,
    },
    otherVaccinations: {
        [Locale.Ru]: `Другие прививки`,
        [Locale.Am]: `Այլ պատվաստումներ`,
        [Locale.En]: `Other vaccinations`,
        [Locale.Pt]: 'Outras vacinas',
        [Locale.Ge]: `Other vaccinations`,
    },
    errorOnSendRegistratioUrl: {
        [Locale.Ru]: `Ошибка отправки ссылки на регистрацию`,
        [Locale.Am]: `Գրանցման հղումն ուղարկելու սխալ`,
        [Locale.En]: `Error sending registration link`,
        [Locale.Pt]: 'Erro ao enviar link de cadastro',
        [Locale.Ge]: `Error sending registration link`,
    },
    errorOnVerificationCode: {
        [Locale.Ru]: `Ошибка отправки кода подтверждения`,
        [Locale.Am]: `Հաստատման կոդն ուղարկելու սխալ`,
        [Locale.En]: `Error sending verification code`,
        [Locale.Pt]: 'Erro ao enviar código de verificação',
        [Locale.Ge]: `Error sending verification code`,
    },
    errorOnEditEntry: {
        [Locale.Ru]: `Ошибка изменения записи`,
        [Locale.Am]: `Գրառման փոփոխման սխալ`,
        [Locale.En]: `Entry modification error`,
        [Locale.Pt]: 'Erro de modificação de entrada',
        [Locale.Ge]: `Entry modification error`,
    },
    errorOnPrimaryChannelChange: {
        [Locale.Ru]: `Ошибка изменении метода уведомления`,
        [Locale.Am]: `Ծանուցման եղանակի փոփոխման սխալ`,
        [Locale.En]: `Error changing notification method`,
        [Locale.Pt]: 'Erro ao alterar o método de notificação',
        [Locale.Ge]: `Error changing notification method`,
    },
    ehrHasDuplicateCantChange: {
        [Locale.Ru]: `У медицинской карты есть дубль, изменение данных возможно только после объединения дублей`,
        [Locale.Am]: `Բժշկական քարտն ունի կրկնօրինակ, տվյալների փոփոխումը հնարավոր է միայն կրկնօրինակների միավորումից հետո`,
        [Locale.En]: `The medical record has a duplicate; changing the data is possible only after merging the duplicates`,
        [Locale.Pt]: 'O prontuário possui segunda via; alterar os dados só é possível após mesclar as duplicatas',
        [Locale.Ge]: `The medical record has a duplicate; changing the data is possible only after merging the duplicates`,
    },
    errorOnBlockEhr: {
        [Locale.Ru]: `Ошибка блокировки пользователя`,
        [Locale.Am]: `Օգտատիրոջ արգելափակման սխալ`,
        [Locale.En]: `Ehr blocked error`,
        [Locale.Pt]: 'Ehr bloqueado erro',
        [Locale.Ge]: `Ehr blocked error`,
    },
    errorOnUnblockEhr: {
        [Locale.Ru]: `Ошибка разблокировки пользователя`,
        [Locale.Am]: `Օգտատիրոջ ապաարգելափակման սխալ`,
        [Locale.En]: `Ehr unlock error`,
        [Locale.Pt]: 'Erro de desbloqueio Ehr',
        [Locale.Ge]: `Ehr unlock error`,
    },
    unsigned: {
        [Locale.Ru]: `Снята подпись`,
        [Locale.Am]: `Ստորագրությունը հանված է`,
        [Locale.En]: `Unsigned`,
        [Locale.Pt]: 'Não assinado',
        [Locale.Ge]: `Unsigned`,
    },
    unsignedSecond: {
        [Locale.Ru]: `Не подписана`,
        [Locale.Am]: `Ստորագրված չէ`,
        [Locale.En]: `Unsigned`,
        [Locale.Pt]: 'Não assinado',
        [Locale.Ge]: `Unsigned`,
    },
    legalRequirements: {
        [Locale.Ru]: `Законные требования`,
        [Locale.Am]: `Օրինական պահանջներ`,
        [Locale.En]: `Legal requirements`,
        [Locale.Pt]: 'Requisitos legais',
        [Locale.Ge]: `Legal requirements`,
    },
    inArchive: {
        [Locale.Ru]: `В архиве`,
        [Locale.Am]: `Արխիվում`,
        [Locale.En]: `In archive`,
        [Locale.Pt]: 'Em arquivo',
        [Locale.Ge]: `In archive`,
    },
    readyForDescribing: {
        [Locale.Ru]: `На описании`,
        [Locale.Am]: `Նկարագրության փուլում`,
        [Locale.En]: `For description`,
        [Locale.Pt]: 'Para descrição',
        [Locale.Ge]: `For description`,
    },
    onReview: {
        [Locale.Ru]: `На проверке`,
        [Locale.Am]: `Ստուգման փուլում`,
        [Locale.En]: `On review`,
        [Locale.Pt]: 'Em revisão',
        [Locale.Ge]: `On review`,
    },
    reviewCompleted: {
        [Locale.Ru]: `Проверена`,
        [Locale.Am]: `Ստուգված է`,
        [Locale.En]: `Review completed`,
        [Locale.Pt]: 'Revisão concluída',
        [Locale.Ge]: `Review completed`,
    },
    cantCreateSameSubacriptions: {
        [Locale.Ru]: `Нельзя создать две действующие подписки на одну и ту же программу.`,
        [Locale.Am]: `Չի կարելի ստեղծել երկու գործող բաժանորդագրություն նույն ծրագրի համար։`,
        [Locale.En]: `You cannot create two active subscriptions for the same program.`,
        [Locale.Pt]: 'Você não pode criar duas assinaturas ativas para o mesmo programa.',
        [Locale.Ge]: `You cannot create two active subscriptions for the same program.`,
    },
    fileAlreadyExists: {
        [Locale.Ru]: `Файл уже существует`,
        [Locale.Am]: `Ֆայլն արդեն գոյություն ունի`,
        [Locale.En]: `The file already exists`,
        [Locale.Pt]: 'O arquivo já existe',
        [Locale.Ge]: `The file already exists`,
    },
    failSaveTranslation: {
        [Locale.Ru]: `Не удалось сохранить перевод`,
        [Locale.Am]: `Չհաջողվեց պահպանել թարգմանությունը`,
        [Locale.En]: `Failed to save translation`,
        [Locale.Pt]: 'Falha ao salvar a tradução',
        [Locale.Ge]: `Failed to save translation`,
    },
    errorOnSaveTranslation: {
        [Locale.Ru]: `При сохранении перевода в поле возникла ошибка`,
        [Locale.Am]: `Դաշտում թարգմանությունը պահպանելիս առաջացել է սխալ`,
        [Locale.En]: `An error occurred while saving the translation in the field`,
        [Locale.Pt]: 'Ocorreu um erro ao salvar a tradução no campo',
        [Locale.Ge]: `An error occurred while saving the translation in the field`,
    },
    renderedServiceNotCreaated: {
        [Locale.Ru]: `Оказанная услуга не создана`,
        [Locale.Am]: `Մատուցված ծառայությունը ստեղծված չէ`,
        [Locale.En]: `The rendered service was not created`,
        [Locale.Pt]: 'O serviço prestado não foi criado',
        [Locale.Ge]: `The rendered service was not created`,
    },
    isInArchive: {
        [Locale.Ru]: `находится в статусе Архив`,
        [Locale.Am]: `գտնվում է Արխիվ կարգավիճակում`,
        [Locale.En]: `is in Archive status`,
        [Locale.Pt]: 'está no status Arquivo',
        [Locale.Ge]: `is in Archive status`,
    },
    fillAndConfirmTranslation: {
        [Locale.Ru]: `Заполните и подтвердите перевод медицинской записи`,
        [Locale.Am]: `Լրացրեք և հաստատեք բժշկական գրառման թարգմանությունը`,
        [Locale.En]: `Complete and confirm the translation of the medical record`,
        [Locale.Pt]: 'Preencher e confirmar a tradução do prontuário médico',
        [Locale.Ge]: `Complete and confirm the translation of the medical record`,
    },
    externalLink: {
        [Locale.Ru]: `Внешняя ссылка`,
        [Locale.Am]: `Արտաքին հղում`,
        [Locale.En]: `External link`,
        [Locale.Pt]: 'Link externo',
        [Locale.Ge]: `External link`,
    },
    covidTesting: {
        [Locale.Ru]: `тестирование на covid-19`,
        [Locale.Am]: `covid-19-ի թեստավորում`,
        [Locale.En]: `testing for covid-19`,
        [Locale.Pt]: 'testes para covid-19',
        [Locale.Ge]: `testing for covid-19`,
    },
    errorOnSigning: {
        [Locale.Ru]: `Возникла ошибка при подписании`,
        [Locale.Am]: `Ստորագրելիս առաջացել է սխալ`,
        [Locale.En]: `An error occurred while signing`,
        [Locale.Pt]: 'Ocorreu um erro ao assinar',
        [Locale.Ge]: `An error occurred while signing`,
    },
    failedGenereateLabel: {
        [Locale.Ru]: `Не удалось сгенерировать этикетку`,
        [Locale.Am]: `Չհաջողվեց գեներացնել պիտակը`,
        [Locale.En]: `Failed to generate label`,
        [Locale.Pt]: 'Falha ao gerar rótulo',
        [Locale.Ge]: `Failed to generate label`,
    },
    printError: {
        [Locale.Ru]: `Ошибка печати`,
        [Locale.Am]: `Տպման սխալ`,
        [Locale.En]: `Print Error`,
        [Locale.Pt]: 'Erro de impressão',
        [Locale.Ge]: `Print Error`,
    },
    printerNotFound: {
        [Locale.Ru]: `Принтер не найден`,
        [Locale.Am]: `Տպիչը չի գտնվել`,
        [Locale.En]: `Printer not found`,
        [Locale.Pt]: 'Impressora não encontrada',
        [Locale.Ge]: `Printer not found`,
    },
    failLinkReservationToEntry: {
        [Locale.Ru]: `Не удалось привязать бронь к записи`,
        [Locale.Am]: `Չհաջողվեց կապել ամրագրումը գրառման հետ`,
        [Locale.En]: `Failed to link booking to entry`,
        [Locale.Pt]: 'Falha ao vincular a reserva à entrada',
        [Locale.Ge]: `Failed to link booking to entry`,
    },
    transalteConfirmOn: {
        [Locale.Ru]: `Подтвержден перевод на`,
        [Locale.Am]: `Հաստատվել է թարգմանությունը՝`,
        [Locale.En]: `Transfer confirmed to`,
        [Locale.Pt]: 'Transferência confirmada para',
        [Locale.Ge]: `Transfer confirmed to`,
    },
    referralsForYourSpecialty: {
        [Locale.Ru]: `Направления по вашей специальности`,
        [Locale.Am]: `Ուղեգրեր ձեր մասնագիտությամբ`,
        [Locale.En]: `Referrals for your specialty`,
        [Locale.Pt]: 'Encaminhamentos da sua especialidade',
        [Locale.Ge]: `Referrals for your specialty`,
    },
    referralToOthers: {
        [Locale.Ru]: `Направления к другим специалистам`,
        [Locale.Am]: `Ուղեգրեր այլ մասնագետների`,
        [Locale.En]: `Referrals to other specialists`,
        [Locale.Pt]: 'Encaminhamentos para outros especialistas',
        [Locale.Ge]: `Referrals to other specialists`,
    },
    labReferrals: {
        [Locale.Ru]: `Лабораторные направления`,
        [Locale.Am]: `Լաբորատոր ուղեգրեր`,
        [Locale.En]: `Laboratory referrals`,
        [Locale.Pt]: 'Encaminhamentos laboratoriais',
        [Locale.Ge]: `Laboratory referrals`,
    },
    entryHasServiceFromReferralText: {
        [Locale.Ru]: `Ответ на это направление выставит услугу, которая уже выставлена в этой записи. Выставить услугу?`,
        [Locale.Am]: `Այս ուղեգրին պատասխանելը կդուրս գրի ծառայություն, որն արդեն դուրս է գրված այս գրառման մեջ։ Դուրս գրե՞լ ծառայությունը`,
        [Locale.En]: `The response to this direction will expose the service that is already posted in this entry. Exhibit a service?`,
        [Locale.Pt]: 'A resposta a esta orientação irá expor o serviço que já está postado nesta entrada. Exibir um serviço?',
        [Locale.Ge]: `The response to this direction will expose the service that is already posted in this entry. Exhibit a service?`,
    },
    currentVersion: {
        [Locale.Ru]: `Текущая версия`,
        [Locale.Am]: `Ընթացիկ տարբերակ`,
        [Locale.En]: `Current version`,
        [Locale.Pt]: 'Versão atual',
        [Locale.Ge]: `Current version`,
    },
    restore: {
        [Locale.Ru]: `Восстановить`,
        [Locale.Am]: `Վերականգնել`,
        [Locale.En]: `Restore`,
        [Locale.Pt]: 'Restaurar',
        [Locale.Ge]: `Restore`,
    },
    restorePassword: {
        [Locale.Ru]: `Восстановить пароль`,
        [Locale.Am]: `Վերականգնել գաղտնաբառը`,
        [Locale.En]: `Restore password`,
        [Locale.Pt]: 'Restaurar senha',
        [Locale.Ge]: `Restore password`,
    },
    restorePasswordSecond: {
        [Locale.Ru]: `Восстановление пароля`,
        [Locale.Am]: `Գաղտնաբառի վերականգնում`,
        [Locale.En]: `Restore password`,
        [Locale.Pt]: 'Restaurar senha',
        [Locale.Ge]: `Restore password`,
    },
    nestedEntryTypeType: {
        [Locale.Ru]: `Тип вложенной записи`,
        [Locale.Am]: `Ներդրված գրառման տեսակ`,
        [Locale.En]: `Sub-entry type`,
        [Locale.Pt]: 'Tipo de subentrada',
        [Locale.Ge]: `Sub-entry type`,
    },
    selectServiceForIDS: {
        [Locale.Ru]: `Выберете услугу для формирования ИДС`,
        [Locale.Am]: `Ընտրեք ծառայությունը տեղեկացված համաձայնություն ձևավորելու համար`,
        [Locale.En]: `Select a service for generating IDS`,
        [Locale.Pt]: 'Selecione um serviço para gerar IDS',
        [Locale.Ge]: `Select a service for generating IDS`,
    },
    addTask: {
        [Locale.Ru]: `Добавить задание`,
        [Locale.Am]: `Ավելացնել առաջադրանք`,
        [Locale.En]: `Add task`,
        [Locale.Pt]: 'Adicionar tarefa',
        [Locale.Ge]: `Add task`,
    },
    recorded: {
        [Locale.Ru]: `Зафиксирована`,
        [Locale.Am]: `Ամրագրված է`,
        [Locale.En]: `Recorded`,
        [Locale.Pt]: 'Gravado',
        [Locale.Ge]: `Recorded`,
    },
    recordedMale: {
        [Locale.Ru]: 'Зафиксировал',
        [Locale.Am]: 'Ամրագրել է',
        [Locale.En]: 'Recorded',
        [Locale.Pt]: 'Gravado',
        [Locale.Ge]: 'Recorded',
    },
    notRecorded: {
        [Locale.Ru]: `Не зафиксирована`,
        [Locale.Am]: `Ամրագրված չէ`,
        [Locale.En]: `Not recorded`,
        [Locale.Pt]: 'Não gravado',
        [Locale.Ge]: `Not recorded`,
    },
    drugDoseSeries: {
        [Locale.Ru]: `Препарат, доза, серия`,
        [Locale.Am]: `Դեղամիջոց, դեղաչափ, սերիա`,
        [Locale.En]: `Drug, dose, series`,
        [Locale.Pt]: 'Medicamento, dose, série',
        [Locale.Ge]: `Drug, dose, series`,
    },
    fixPateintAgrmText: {
        [Locale.Ru]: `Зафиксируйте договоренности с пациентом и статус решения эпизода`,
        [Locale.Am]: `Ամրագրեք պացիենտի հետ պայմանավորվածությունները և էպիզոդի լուծման կարգավիճակը`,
        [Locale.En]: `Record agreements with the patient and the resolution status of the episode`,
        [Locale.Pt]: 'Registrar acordos com o paciente e o status de resolução do episódio',
        [Locale.Ge]: `Record agreements with the patient and the resolution status of the episode`,
    },
    backToPatients: {
        [Locale.Ru]: `Вернуться к пациентам`,
        [Locale.Am]: `Վերադառնալ պացիենտներին`,
        [Locale.En]: `Back to patients`,
        [Locale.Pt]: 'De volta aos pacientes',
        [Locale.Ge]: `Back to patients`,
    },
    unableToMergeEhrs: {
        [Locale.Ru]: `Невозможно объединить карты`,
        [Locale.Am]: `Անհնար է միավորել քարտերը`,
        [Locale.En]: `Unable to merge cards`,
        [Locale.Pt]: 'Não é possível mesclar cartões',
        [Locale.Ge]: `Unable to merge cards`,
    },
    mergeEhrs: {
        [Locale.Ru]: `Объединить карты`,
        [Locale.Am]: `Միավորել քարտերը`,
        [Locale.En]: `Merge cards`,
        [Locale.Pt]: 'Mesclar cartões',
        [Locale.Ge]: `Merge cards`,
    },
    balanceShouldBeZero: {
        [Locale.Ru]: `Баланс присоеденяемых карт должен быть 0`,
        [Locale.Am]: `Միացվող քարտերի մնացորդը պետք է լինի 0`,
        [Locale.En]: `The balance of the connected cards must be 0`,
        [Locale.Pt]: 'O saldo dos cartões conectados deve ser 0',
        [Locale.Ge]: `The balance of the connected cards must be 0`,
    },
    errorOnMerging: {
        [Locale.Ru]: `Ошибка при объединении`,
        [Locale.Am]: `Սխալ միավորման ժամանակ`,
        [Locale.En]: `Error while merging`,
        [Locale.Pt]: 'Erro ao mesclar',
        [Locale.Ge]: `Error while merging`,
    },
    cardNumber: {
        [Locale.Ru]: `Номер карты`,
        [Locale.Am]: `Քարտի համար`,
        [Locale.En]: `Card number`,
        [Locale.Pt]: 'Número do prontuário',
        [Locale.Ge]: `Card number`,
    },
    medicalCardNumber: {
        [Locale.Ru]: `Номер медкарты`,
        [Locale.Am]: `Բժշկական քարտի համար`,
        [Locale.En]: `Medical card number`,
        [Locale.Pt]: 'Número do cartão médico',
        [Locale.Ge]: `Medical card number`,
    },
    specialConditions: {
        [Locale.Ru]: `Специальные условия`,
        [Locale.Am]: `Հատուկ պայմաններ`,
        [Locale.En]: `Special conditions`,
        [Locale.Pt]: 'Condições especiais',
        [Locale.Ge]: `Special conditions`,
    },
    automaticDebit: {
        [Locale.Ru]: `Автосписание`,
        [Locale.Am]: `Ավտոմատ դուրսգրում`,
        [Locale.En]: `Automatic debit`,
        [Locale.Pt]: 'Débito automático',
        [Locale.Ge]: `Automatic debit`,
    },
    currentCostPerMonth: {
        [Locale.Ru]: `Текущая стоимость в месяц`,
        [Locale.Am]: `Ընթացիկ արժեքն ամսական`,
        [Locale.En]: `Current cost per month`,
        [Locale.Pt]: 'Custo atual por mês',
        [Locale.Ge]: `Current cost per month`,
    },
    currentCostPerYear: {
        [Locale.Ru]: `Текущая стоимость в год`,
        [Locale.Am]: `Ընթացիկ արժեքը տարեկան`,
        [Locale.En]: `Current cost per year`,
        [Locale.Pt]: 'Custo atual por ano',
        [Locale.Ge]: `Current cost per year`,
    },
    costOfAdmission: {
        [Locale.Ru]: `Стоимость приема`,
        [Locale.Am]: `Ընդունելության արժեք`,
        [Locale.En]: `Cost of admission`,
        [Locale.Pt]: 'Custo de admissão',
        [Locale.Ge]: `Cost of admission`,
    },
    lastViewed: {
        [Locale.Ru]: `Последние просмотренные`,
        [Locale.Am]: `Վերջին դիտվածները`,
        [Locale.En]: `Last viewed`,
        [Locale.Pt]: 'Visto pela última vez',
        [Locale.Ge]: `Last viewed`,
    },
    forToday: {
        [Locale.Ru]: `На сегодня`,
        [Locale.Am]: `Այսօրվա համար`,
        [Locale.En]: `For today`,
        [Locale.Pt]: 'Por hoje',
        [Locale.Ge]: `For today`,
    },
    subscriptionOrder: {
        [Locale.Ru]: `Подписка`,
        [Locale.Am]: `Բաժանորդագրություն`,
        [Locale.En]: `Membership`,
        [Locale.Pt]: 'Associação',
        [Locale.Ge]: `Membership`,
    },
    'subscription-order': {
        [Locale.Ru]: `Подписки`,
        [Locale.Am]: `Բաժանորդագրություններ`,
        [Locale.En]: `Memberships`,
        [Locale.Pt]: 'Associações',
        [Locale.Ge]: `Memberships`,
    },
    alreadySent: {
        [Locale.Ru]: 'Письмо уже отправлено на email',
        [Locale.Am]: 'Նամակն արդեն ուղարկվել է էլ. հասցեին',
        [Locale.En]: 'Email already sent',
        [Locale.Pt]: 'E-mail já enviado',
        [Locale.Ge]: 'Email already sent',
    },
    checkEmail: {
        [Locale.Ru]: 'Проверьте e-mail',
        [Locale.Am]: 'Ստուգեք էլ. հասցեն',
        [Locale.En]: 'Check e-mail',
        [Locale.Pt]: 'Verifique e-mail',
        [Locale.Ge]: 'Check e-mail',
    },
    sessionExpired: {
        [Locale.Ru]: 'Сессия истекла',
        [Locale.Am]: 'Սեսիայի ժամկետը լրացել է',
        [Locale.En]: 'Session expired',
        [Locale.Pt]: 'Sessão expirada',
        [Locale.Ge]: 'Session expired',
    },
    loginAgain: {
        [Locale.Ru]: 'Войдите заново',
        [Locale.Am]: 'Մուտք գործեք կրկին',
        [Locale.En]: 'Login again',
        [Locale.Pt]: 'Faça login novamente',
        [Locale.Ge]: 'Login again',
    },
    passwordTooShort: {
        [Locale.Ru]: 'Пароль должен быть не короче 6 символов',
        [Locale.Am]: 'Գաղտնաբառը պետք է լինի առնվազն 6 նիշ',
        [Locale.En]: 'Password must be at least 6 characters',
        [Locale.Pt]: 'A senha deve ter pelo menos 6 caracteres',
        [Locale.Ge]: 'Password must be at least 6 characters',
    },
    passwordsDoNotMatch: {
        [Locale.Ru]: 'Пароли не совпадают',
        [Locale.Am]: 'Գաղտնաբառերը չեն համընկնում',
        [Locale.En]: 'Passwords do not match',
        [Locale.Pt]: 'As senhas não coincidem',
        [Locale.Ge]: 'Passwords do not match',
    },
    $freeChatSubscriptionsText: {
        [Locale.Ru]: 'Бесплатный чат действует $days. После этого пациенту будет предложена стандартная цена подписки на доктора — $cost',
        [Locale.Am]: 'Անվճար չաթը գործում է $days։ Դրանից հետո պացիենտին կառաջարկվի բժշկի բաժանորդագրության ստանդարտ գինը՝ $cost',
        [Locale.En]: 'Free chat subscription is valid for $days. After that, the patient will be offered the standard price of a subscription to the doctor — $cost',
        [Locale.Pt]: 'A assinatura gratuita do chat é válida por $days. Depois disso, será oferecido ao paciente o preço padrão de uma assinatura do médico – $cost',
        [Locale.Ge]: 'უფასო ჩატი მოქმედებს $days. ამის შემდეგ პაციენტს შესთავაზებენ ექიმის გამოწერის სტანდარტულ ფასს — $cost',
    },
    limitedTime: {
        [Locale.Ru]: 'ограниченное время',
        [Locale.Am]: 'սահմանափակ ժամկետով',
        [Locale.En]: 'a limited time',
        [Locale.Pt]: 'tempo limitado',
        [Locale.Ge]: 'შეზღუდული დროით',
    },
    noSubscriptionCost: {
        [Locale.Ru]: 'Не задана цена на подписку',
        [Locale.Am]: 'Բաժանորդագրության գինը սահմանված չէ',
        [Locale.En]: 'Subscription price is not set',
        [Locale.Pt]: 'O preço da assinatura não está definido',
        [Locale.Ge]: 'Subscription price is not set',
    },
    setSubscriptionCost: {
        [Locale.Ru]: 'Установить цену на подписку',
        [Locale.Am]: 'Սահմանել բաժանորդագրության գինը',
        [Locale.En]: 'Set subscription price',
        [Locale.Pt]: 'Definir preço de assinatura',
        [Locale.Ge]: 'Set subscription price',
    },
    patientDontUseChaikaChatText: {
        [Locale.Ru]: 'Пациент не пользуется Chaika Chat, поэтому нужно отправить приглашение',
        [Locale.Am]: 'Պացիենտը չի օգտվում Chaika Chat-ից, ուստի անհրաժեշտ է ուղարկել հրավեր',
        [Locale.En]: 'Patient does not use Chaika Chat, so you need to send an invitation',
        [Locale.Pt]: 'O paciente não usa o Chaika Chat, então você precisa enviar um convite',
        [Locale.Ge]: 'Patient does not use Chaika Chat, so you need to send an invitation',
    },
    selectPracticeForTopicText: {
        [Locale.Ru]: 'Выберите, с какой практикой создать топик для пациента',
        [Locale.Am]: 'Ընտրեք, թե որ պրակտիկայի հետ ստեղծել թոփիկ պացիենտի համար',
        [Locale.En]: 'Select which practice to create a patient topic with',
        [Locale.Pt]: 'Selecione com qual clínica criar um tópico de paciente',
        [Locale.Ge]: 'Select which practice to create a patient topic with',
    },
    selectDocrotForTopicText: {
        [Locale.Ru]: 'Выберите, с каким доктором создать топик для пациента',
        [Locale.Am]: 'Ընտրեք, թե որ բժշկի հետ ստեղծել թոփիկ պացիենտի համար',
        [Locale.En]: 'Select which doctor to create a topic for the patient with',
        [Locale.Pt]: 'Selecione com qual médico criar um tópico para o paciente',
        [Locale.Ge]: 'Select which practice to create a patient topic with',
    },
    messageForPatient: {
        [Locale.Ru]: 'Сообщение для пациента',
        [Locale.Am]: 'Հաղորդագրություն պացիենտի համար',
        [Locale.En]: 'Message for patient',
        [Locale.Pt]: 'Mensagem para o paciente',
        [Locale.Ge]: 'Message for patient',
    },
    editSubscriptionTerms: {
        [Locale.Ru]: 'Настроить условия подписки',
        [Locale.Am]: 'Կարգավորել բաժանորդագրության պայմանները',
        [Locale.En]: 'Edit subscription terms',
        [Locale.Pt]: 'Editar termos de assinatura',
        [Locale.Ge]: 'Edit subscription terms',
    },
    deleteSpecialTerms: {
        [Locale.Ru]: `Удалить специальные условия`,
        [Locale.Am]: `Ջնջել հատուկ պայմանները`,
        [Locale.En]: `Delete special terms`,
        [Locale.Pt]: 'Excluir termos especiais',
        [Locale.Ge]: `Delete special terms`,
    },
    applyNewTerms: {
        [Locale.Ru]: `Применить новые условия`,
        [Locale.Am]: `Կիրառել նոր պայմանները`,
        [Locale.En]: `Apply new terms`,
        [Locale.Pt]: 'Aplicar novos termos',
        [Locale.Ge]: `Apply new terms`,
    },
    marginMinusFixedAmount: {
        [Locale.Ru]: `Маржа минус фикс сумма`,
        [Locale.Am]: `Մարժա հանած ֆիքսված գումար`,
        [Locale.En]: `Margin minus fixed amount`,
        [Locale.Pt]: 'Margem menos valor fixo',
        [Locale.Ge]: `Margin minus fixed amount`,
    },
    // NAME: {
    //     [Locale.Ru]: ``,
    //     [Locale.Am]: ``,
    //     [Locale.En]: ``,
    // [Locale.Pt]: '',
    //     [Locale.Ge]: ``,
    // },
};
